export const transformQuestionnaireResponse = questionnaireResponse => ({
  ...questionnaireResponse,
  fhir: JSON.parse(questionnaireResponse.fhir),
  questionnaire: {
    ...questionnaireResponse.questionnaire,
    fhir: JSON.parse(questionnaireResponse.questionnaire.fhir),
  },
});
